import { Box } from "theme-ui";

export default function ChevronLeftIcon(props) {
  return (
    <Box
      as="svg"
      width="10"
      height="17"
      viewBox="0 0 10 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.14645 16.8536C9.34171 17.0488 9.65829 17.0488 9.85355 16.8536C10.0488 16.6583 10.0488 16.3417 9.85355 16.1464L9.14645 16.8536ZM1.5 8.5L1.14645 8.14645L0.792893 8.5L1.14645 8.85355L1.5 8.5ZM9.85355 0.853553C10.0488 0.658291 10.0488 0.341709 9.85355 0.146447C9.65829 -0.0488155 9.34171 -0.0488155 9.14645 0.146447L9.85355 0.853553ZM9.85355 16.1464L1.85355 8.14645L1.14645 8.85355L9.14645 16.8536L9.85355 16.1464ZM1.85355 8.85355L9.85355 0.853553L9.14645 0.146447L1.14645 8.14645L1.85355 8.85355Z"
        fill="black"
      />
    </Box>
  );
}
